import type { OutcomesApi } from "@/v2/api/metadata/outcomes";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { outcomeGamesStatusOptions } from "../../../../shared";
import { notifySuccess, outcomeId } from "../shared";

const prematchTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "prematchGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: outcomeGamesStatusOptions,
        inheritance: { computedKey: "computedStatus", parentKey: "parentStatus" },
      },
    ],
  },
];

export function createPrematchTab(outcomesApi: OutcomesApi): ContentTab {
  return {
    id: "prematch",
    label: "Prematch",
    save: createInheritableTabSave({
      children: prematchTabChildren,
      persist: async (patch, ctx: DialogTabSaveContext) => {
        await outcomesApi.update(outcomeId(ctx.values), patch);
        notifySuccess();
      },
    }),
    children: prematchTabChildren,
  };
}
